webpackJsonp([50],{

/***/ "akPD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/success-stories-list-item_6f9b6a4f80fd1c8dd3b9e1f135ff10ce.html";

/***/ }),

/***/ "paAm":
/***/ (function(module, exports, __webpack_require__) {

var SuccessStoriesListItem = (function () {
    function SuccessStoriesListItem() {
    }
    return SuccessStoriesListItem;
}());
angular.module('animatronApp.successStoriesListItem', []).component('successStoriesListItem', {
    bindings: {
        logo: '<?',
        description: '<?',
        backgroundImage: '<',
    },
    controller: SuccessStoriesListItem,
    templateUrl: __webpack_require__("akPD")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/50-28dc41a6a889e793a2e2.min.js